import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import './profile.css';
import PUPageContent from '../../common/PUPageContent';
import SUPageContent from '../../common/SUPageContent';

import { NUT_THEME_USERS, ROLES } from '../../utils/constants';
import CustomPageContent from "../../common/Profile";
import { connect, useDispatch } from 'react-redux';
import { setOtherUserProfile } from '../../../redux/actions/otherUser';

const Profile = ({
    userInformation
}) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [user, setUser] = useState({});
    const [username, setUsername] = useState('');
    const isLoggedIn = localStorage.getItem('loggedin_user');
    const isMountedRef = useRef(true);

    const getLogin = () => window.location.pathname.split(/\?|#/)[0].replace('/', '');

    const getUserInformation = async (login = null) => {
        const loginName = login || username;
        await axios.get(`/api/profile/${loginName}`)
            .then((response) => {
                if (!isMountedRef.current) {
                    return null;
                }

                if (response.data && Object.keys(response.data).length > 0) {
                    setUser(response.data);

                    dispatch(setOtherUserProfile(response.data));

                    if (response.data.subscription_status === 0) {
                        $('.main-app').removeClass('not-following');
                        $('.main-app').addClass('is-following');
                    } else {
                        $('.main-app').removeClass('is-following');
                        $('.main-app').addClass('not-following');
                    }
                } else {
                    history.push(`/${userInformation.login}`);
                }

                // use darkmode if user is karen7 or nut
                if (NUT_THEME_USERS.includes(response.data.id)) {
                    $('body').removeClass('lightmode');
                    $('body').addClass('themeblk darkmode');
                }
            })
            .catch((error) => {
                console.log({ error });

                if (error && error.response && error.response.status === 404) {
                    history.push('/404');
                }
            });
    };

    const handleRouteChange = () => {
        const login = getLogin();
        setUsername(login);
    };

    useEffect(() => {
        if (isMountedRef.current) {
            setUsername(getLogin());
        }

        return () => {
            isMountedRef.current = false;

            const darkMode = localStorage.getItem('darkmode');
            $('body').removeClass('themeblk');
            if (darkMode == 'true') {
                $('body').removeClass('lightmode');
                $('body').addClass('darkmode');
            } else {
                $('body').removeClass('darkmode');
                $('body').addClass('lightmode');
            }

        };
    }, []);

    useEffect(() => {
        if (username) {
            getUserInformation();
        }
    }, [username]);

    useEffect(() => {
        const unlisten = history.listen(() => {
            handleRouteChange();
        });

        return () => {
            unlisten();
        };
    }, [history]);

    useEffect(() => {
        const handleGetCreatorInformation = () => {
            getUserInformation(getLogin());
        };

        window.addEventListener('profile/getCreatorInformation', handleGetCreatorInformation);

        return () => {
            window.removeEventListener('profile/getCreatorInformation', handleGetCreatorInformation);
        };
    }, []);


    if (userInformation && Object.keys(userInformation).length > 0 && user && Object.keys(user).length > 0 && String(isLoggedIn) === String(user.id)) {
        return (
            <>
                {
                    userInformation.role === ROLES.SU && <SUPageContent user={user} getUserInformation={getUserInformation} userInformation={userInformation} />
                }
                {
                    [ROLES.PU, ROLES.ADMIN].includes(parseInt(userInformation.role)) && <PUPageContent user={user} getUserInformation={getUserInformation} userInformation={userInformation} />
                }
            </>
        );
    }

    return Object.keys(user).length > 0 && <CustomPageContent user={user} getUserInformation={getUserInformation} />;
};

const mapStateToProps = state => ({
    userInformation: state.user.user
});

export default connect(mapStateToProps)(React.memo(Profile));
